import { useLayoutEffect } from "react";

export interface PreloadLink {
  href: string;
  as: string;
  type?: string;
  media?: string;
  imagesrcset?: string;
  imagesizes?: string;
  fetchpriority?: string;
}

/** Dependency-free <link rel="preload"> injector (replaces the old Helmet usage). */
const HeadPreload = ({ links }: { links: PreloadLink[] }) => {
  const key = JSON.stringify(links);

  useLayoutEffect(() => {
    const created = links.map((cfg) => {
      const el = document.createElement("link");
      el.setAttribute("rel", "preload");
      Object.entries(cfg).forEach(([k, v]) => {
        if (v) el.setAttribute(k, String(v));
      });
      el.setAttribute("data-seo-preload", "1");
      document.head.appendChild(el);
      return el;
    });
    return () => created.forEach((el) => el.remove());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [key]);

  return null;
};

export default HeadPreload;
